import React, { useEffect, useState } from 'react';
import { initMercadoPago } from '@mercadopago/sdk-react';

const TestMercadoPago = () => {
  const [mpInitialized, setMpInitialized] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const publicKey = process.env.REACT_APP_MP_PUBLIC_KEY;
    
    console.log('🔑 Verificando credenciales...');
    console.log('Public Key:', publicKey ? '✅ Configurada' : '❌ No encontrada');
    console.log('Access Token:', process.env.REACT_APP_MP_ACCESS_TOKEN ? '✅ Configurada' : '❌ No encontrada');
    
    if (publicKey) {
      try {
        initMercadoPago(publicKey, {
          locale: 'es-AR'
        });
        setMpInitialized(true);
        console.log('✅ Mercado Pago inicializado correctamente');
      } catch (err) {
        setError('Error al inicializar Mercado Pago: ' + err.message);
        console.error('❌ Error:', err);
      }
    } else {
      setError('No se encontró la Public Key en las variables de entorno');
    }
  }, []);

  const testAPIConnection = async () => {
    try {
      console.log('🧪 Probando conexión con la API...');
      
      // Test básico - crear una preferencia de pago simple
      const testPayment = {
        items: [
          {
            title: 'Test - Plan Constructora',
            quantity: 1,
            unit_price: 100
          }
        ],
        back_urls: {
          success: window.location.origin + '/success',
          failure: window.location.origin + '/failure',
          pending: window.location.origin + '/pending'
        },
        auto_return: 'approved'
      };

      // Aquí simularíamos la llamada al backend
      console.log('📦 Datos de prueba preparados:', testPayment);
      alert('✅ Configuración correcta! Los datos están listos para enviar al backend.');
      
    } catch (error) {
      console.error('❌ Error en el test:', error);
      alert('❌ Error: ' + error.message);
    }
  };

  return (
    <div style={{ 
      padding: '20px', 
      maxWidth: '600px', 
      margin: '20px auto',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h2>🧪 Test de Mercado Pago</h2>
      
      <div style={{ 
        background: '#f5f5f5', 
        padding: '15px', 
        borderRadius: '8px',
        marginBottom: '20px'
      }}>
        <h3>📋 Estado de la configuración:</h3>
        
        <div style={{ marginBottom: '10px' }}>
          <strong>Public Key:</strong> 
          <span style={{ color: process.env.REACT_APP_MP_PUBLIC_KEY ? 'green' : 'red' }}>
            {process.env.REACT_APP_MP_PUBLIC_KEY ? ' ✅ Configurada' : ' ❌ No encontrada'}
          </span>
        </div>
        
        <div style={{ marginBottom: '10px' }}>
          <strong>Access Token:</strong> 
          <span style={{ color: process.env.REACT_APP_MP_ACCESS_TOKEN ? 'green' : 'red' }}>
            {process.env.REACT_APP_MP_ACCESS_TOKEN ? ' ✅ Configurada' : ' ❌ No encontrada'}
          </span>
          {process.env.REACT_APP_MP_ACCESS_TOKEN && 
            <small style={{ display: 'block', color: '#666' }}>
              Longitud: {process.env.REACT_APP_MP_ACCESS_TOKEN.length} caracteres
              {process.env.REACT_APP_MP_ACCESS_TOKEN.length < 20 && 
                <span style={{ color: 'orange' }}> ⚠️ Parece incompleto</span>
              }
            </small>
          }
        </div>
        
        <div style={{ marginBottom: '10px' }}>
          <strong>SDK Inicializado:</strong> 
          <span style={{ color: mpInitialized ? 'green' : 'red' }}>
            {mpInitialized ? ' ✅ Correcto' : ' ❌ Error'}
          </span>
        </div>
        
        {error && (
          <div style={{ 
            background: '#ffebee', 
            color: '#c62828', 
            padding: '10px', 
            borderRadius: '4px',
            marginTop: '10px'
          }}>
            <strong>❌ Error:</strong> {error}
          </div>
        )}
      </div>

      <div style={{ textAlign: 'center' }}>
        <button
          onClick={testAPIConnection}
          disabled={!mpInitialized}
          style={{
            background: mpInitialized ? '#00a650' : '#ccc',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '6px',
            fontSize: '16px',
            cursor: mpInitialized ? 'pointer' : 'not-allowed'
          }}
        >
          🧪 Probar Configuración
        </button>
      </div>

      <div style={{ 
        marginTop: '20px', 
        padding: '15px',
        background: '#e3f2fd',
        borderRadius: '8px'
      }}>
        <h4>📝 Siguientes pasos:</h4>
        <ol>
          <li>Verificar que el archivo .env esté creado</li>
          <li>Reiniciar el servidor de desarrollo (npm start)</li>
          <li>Comprobar que las credenciales sean completas</li>
          <li>Probar la configuración con este botón</li>
        </ol>
      </div>
    </div>
  );
};

export default TestMercadoPago; 